<script>
export default {
	name: 'BaseStatusIcon',
	props: { status: String, typeLabel: Boolean }
}
</script>

<template>
	<div class="base-status-icon">
		<div class="base-status-icon__circle base-status-icon__circle--in-progress"
			:class="[{'base-status-icon__circle--complete' : status==='COMPLETE'}, {'base-status-icon__circle--invalid' : status==='INVALID'}, {'base-status-icon__oval' : typeLabel}]">
			<div v-if="typeLabel && status">{{ $t('enrollment.' + status.toLowerCase()) }}</div>
		</div>
	</div>
</template>

<style lang="scss">
	.base-status-icon {
		display: inline-block;
		&__circle {
			display: inline-block;
			border-radius: 10px;
			height: 20px;
			width: 20px;
			font-size: 0.75rem;
			vertical-align: middle;
			&--in-progress {
				background-color: #FDE097;
				color: #85671B;
			}
			&--complete {
				background-color: #BADD96;
				color: #27420D;
			}
			&--invalid {
				background-color: #F48686;
				color: #851B1B;
			}
		}
		&__oval {
			width: 85px;
			display: flex;
			justify-content: center;
			align-items: center;
		}
		&__label {
			padding-top: 0.2rem;
			text-align: center;
		}
	}
</style>
